'use client'; // Error boundaries must be Client Components

import classes from '@/utils/style/error/error.module.css';
import { Container, SimpleGrid, Title } from '@mantine/core';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

export default function Error({ error }: { error: Error & { digest?: string } }) {
	const t = useTranslations('Error');
	useEffect(() => {
		// Log the error to an error reporting service
		console.error(error);
	}, [error]);

	return (
		<Container className={classes.root}>
			<SimpleGrid
				style={{ alignItems: 'center' }}
				spacing={{ base: 40, sm: 80 }}
				cols={{ base: 1, sm: 2 }}
				className={classes.textImage}
			>
				<div className={classes.text}>
					<Title className={classes.title}>{t('unspecific')}</Title>
				</div>
			</SimpleGrid>
		</Container>
	);
}
